import React, {forwardRef} from "react";
import {Input} from '@mantine/core';
import {useField} from "formik";

const MantineInputRefField = (props, ref) => {
    const {name, label} = props;
    const [meta] = useField(name);

    return (
        <Input.Wrapper
            id={`wrapper-${name}`}
            withAsterisk
            label={label}
            error={meta.error && meta.touched && <div>{meta.error}</div>}
            styles={{
                label: {marginLeft: "-44px", fontSize: "14px"},
                root: {width: "101%"}
            }}
        >
            <Input
                styles={{
                    input: {width: "101%"}
                }}
                {...props}
                id={name}
                ref={ref}
            />
        </Input.Wrapper>
    );
};

export default forwardRef(MantineInputRefField);